import { CALL_API, Schemas } from '../../common/middleware/api';

export const USERS_REQUEST = 'USERS_REQUEST';
export const USERS_SUCCESS = 'USERS_SUCCESS';
export const USERS_FAILURE = 'USERS_FAILURE';

export const USER_FETCH_REQUEST = 'USER_GET_REQUEST';
export const USER_FETCH_SUCCESS = 'USER_GET_SUCCESS';
export const USER_FETCH_FAILURE = 'USER_GET_FAILURE';

export const USER_CREATE_REQUEST = 'USER_CREATE_REQUEST';
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_CREATE_FAILURE = 'USER_CREATE_FAILURE';

export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE';

export const USER_MAPPING_FETCH_REQUEST = 'USER_MAPPING_GET_REQUEST';
export const USER_MAPPING_FETCH_SUCCESS = 'USER_MAPPING_GET_SUCCESS';
export const USER_MAPPING_FETCH_FAILURE = 'USER_MAPPING_GET_FAILURE';

export const USER_MAPPING_CREATE_REQUEST = 'USER_MAPPING_CREATE_REQUEST';
export const USER_MAPPING_CREATE_SUCCESS = 'USER_MAPPING_CREATE_SUCCESS';
export const USER_MAPPING_CREATE_FAILURE = 'USER_MAPPING_CREATE_FAILURE';

export const USER_MAPPING_UPDATE_REQUEST = 'USER_MAPPING_UPDATE_REQUEST';
export const USER_MAPPING_UPDATE_SUCCESS = 'USER_MAPPING_UPDATE_SUCCESS';
export const USER_MAPPING_UPDATE_FAILURE = 'USER_MAPPING_UPDATE_FAILURE';

export const USER_FORGOT_PASSWORD_REQUEST = 'USER_FORGOT_PASSWORD_REQUEST';
export const USER_FORGOT_PASSWORD_SUCCESS = 'USER_FORGOT_PASSWORD_SUCCESS';
export const USER_FORGOT_PASSWORD_FAILURE = 'USER_FORGOT_PASSWORD_FAILURE';

export const USER_FORGOT_PASSWORD_URL_REQUEST = 'USER_FORGOT_PASSWORD_URL_REQUEST';
export const USER_FORGOT_PASSWORD_URL_SUCCESS = 'USER_FORGOT_PASSWORD_URL_SUCCESS';
export const USER_FORGOT_PASSWORD_URL_FAILURE = 'USER_FORGOT_PASSWORD_URL_FAILURE';

export const loadUsers = (options) => ({
	[CALL_API]: {
		types: [USERS_REQUEST, USERS_SUCCESS, USERS_FAILURE],
		endpoint: 'api/systemUsers',
		request: options,
		schema: Schemas.USER_ARRAY
	}
});

export const fetchUser = (id) => ({
	[CALL_API]: {
		types: [USER_FETCH_REQUEST, USER_FETCH_SUCCESS, USER_FETCH_FAILURE],
		endpoint: `api/systemUsers/${id}`,
		schema: Schemas.USER
	}
});

export const createUser = (user, history) => ({
	[CALL_API]: {
		types: [USER_CREATE_REQUEST, USER_CREATE_SUCCESS, USER_CREATE_FAILURE],
		endpoint: 'api/systemUsers',
		method: 'POST',
		request: user,
		schema: Schemas.USER,
		form: 'newUser',
		transition: {
			history,
			successPath: (response) => {
				return `/users/${response.result}`;
			}
		}
	}
});

export const updateUser = (id, user) => ({
	[CALL_API]: {
		types: [USER_UPDATE_REQUEST, USER_UPDATE_SUCCESS, USER_UPDATE_FAILURE],
		endpoint: `api/systemUsers/${id}`,
		method: 'PUT',
		request: user,
		schema: Schemas.USER,
		form: 'user'
	}
});

export const fetchUserMapping = (userId) => ({
	[CALL_API]: {
		types: [USER_MAPPING_FETCH_REQUEST, USER_MAPPING_FETCH_SUCCESS, USER_MAPPING_FETCH_FAILURE],
		endpoint: `api/systemUserMappings/byUser/${userId}`,
		schema: Schemas.USER_MAPPING
	}
});

export const createUserMapping = (userMapping, history, onSuccessEvent) => ({
	[CALL_API]: {
		types: [USER_MAPPING_CREATE_REQUEST, USER_MAPPING_CREATE_SUCCESS, USER_MAPPING_CREATE_FAILURE],
		endpoint: 'api/systemUserMappings',
		method: 'POST',
		request: userMapping,
		schema: Schemas.USER_MAPPING,
		form: 'userMappingForm',
		onSuccessEvent,
		transition: {
			history,
			successPath: (response) => {
				return `/users/${response.result}`;
			}
		}
	}
});

export const updateUserMapping = (id, userMapping, onSuccessEvent) => ({
	[CALL_API]: {
		types: [USER_MAPPING_UPDATE_REQUEST, USER_MAPPING_UPDATE_SUCCESS, USER_MAPPING_UPDATE_FAILURE],
		endpoint: `api/systemUserMappings/${id}`,
		method: 'PUT',
		request: userMapping,
		schema: Schemas.USER_MAPPING,
		form: 'userMappingForm',
		onSuccessEvent
	}
});

export const requestPasswordReset = (id) => ({
	[CALL_API]: {
		types: [USER_FORGOT_PASSWORD_REQUEST, USER_FORGOT_PASSWORD_SUCCESS, USER_FORGOT_PASSWORD_FAILURE],
		endpoint: `api/systemUsers/${id}/passwordReset`,
		method: 'POST'
	}
});

export const requestPasswordResetUrl = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [USER_FORGOT_PASSWORD_URL_REQUEST, USER_FORGOT_PASSWORD_URL_SUCCESS, USER_FORGOT_PASSWORD_URL_FAILURE],
		endpoint: `api/systemUsers/${id}/passwordResetUrl`,
		onSuccessEvent
	}
});